module.exports = __webpack_public_path__ + "img/swiper8.ca15b61d.jpg";